import styles from './SingleCard.module.scss';

import cx from 'classnames';
import { ContentImage } from 'components/ContentImage/ContentImage';
import { ContentLinkV2 } from 'components/ContentLinkV2/ContentLinkV2';
import { useBreakpoints } from 'hooks/useBreakpoints';
import React from 'react';
import { toEntry, AppType } from 'services/cms/typesUtil';
import { Grid } from '../../Grid/Grid';
import { TextV2 } from '../../TextV2/TextV2';
import { SINGLE_CARD_TEST_ID } from './SingleCard.const';

type SingleCardProps = AppType.Component<{
  item: AppType.Content;
  theme?: string;
}>;

export const SingleCard: React.FC<SingleCardProps> = ({ item }) => {
  const { headline, body, desktopTabletImage, ctaLink, mobileImage } = item || {};
  const { browser } = useBreakpoints();
  const isDesktopOrLarge = browser.is.desktop;
  const isMobile = browser.is.mobile;

  const getArrowContainer = () => (
    <div className={cx({ [styles.singleCardBodyArrowContainer]: isDesktopOrLarge })}>
      <TextV2 value={body} variant="body" tagName="p" className={styles.singleCardBody} />
      {isDesktopOrLarge && <span aria-hidden="true" className={styles.cardArrow} />}
    </div>
  );

  const cardContents = () => (
    <>
      <ContentImage
        entry={isMobile && mobileImage ? mobileImage : desktopTabletImage}
        className={styles.singleCardImage}
        aria-hidden="true"
      />
      {!desktopTabletImage && <div className={styles.singleCardSpacer} />}
      {headline && (
        <TextV2 value={headline} variant="h4-medium" tagName="h4" className={styles.singleCardHeadline} />
      )}
      {body && getArrowContainer()}
      {!desktopTabletImage && <div className={styles.singleCardSpacer} />}
    </>
  );

  return (
    <Grid item className={styles.singleCard}>
      <ContentLinkV2 entry={toEntry(ctaLink)} hideTitle data-testid={SINGLE_CARD_TEST_ID.singleGridLink}>
        {cardContents()}
      </ContentLinkV2>
    </Grid>
  );
};
